import EntryPoint from "../../../containers/Profile/MyBuys/MyBuysContainer";
import Management from "../../../containers/Profile/MyBuys/Management/ManagementContainer";
import Inspection from "../../../containers/Profile/Inspection/EntryPointContainer";
import QRGenerator from "../../../containers/Profile/QrGenerator/EntryPointContainer";
import { RouteObject } from "../../../interfaces/navigation";

export const myBuysSubRoutes: RouteObject[] = [
    {
        title: "Gestión",
        path: ":id/gestion",
        component: <Management/>
    },
    {
        title: "Qr Generator",
        path: ":id/qr_generador",
        component: <QRGenerator/>
    },
    {
        title: "Inspección",
        path: ":id/inspeccion",
        component: <Inspection/>
    }
];

export const myBuysRoutes: RouteObject[] = [
    {
        title: "Mi actividad",
        path: "mis_compras",
        component: <EntryPoint/>,
        subRoutes: myBuysSubRoutes
    }
];